module.exports = __webpack_public_path__ + "img/logo.92003592.png";